import PracticeForm from "./PracticeForm";
import PracticeSelect from "./PracticeSelect";
import Table from "./Table";

export { PracticeForm, PracticeSelect, Table };
